<template>
  <div class="home-bottom">
    <div class="company-addr" :style="{ margin: $route.path == '/login' ? '0 auto' : '' }">
      <div class="addr-left">
        <div class="source-company">武汉梦知网知识产权服务有限公司</div>
        <div class="source-address">
          地址：湖北省武汉市武昌区武珞路456号新时代商务中心主楼23层6号
        </div>
        <div class="source-email">邮箱：biaoyuan@quandashi.com</div>
      </div>
      <div class="addr-right">
        <div class="right-mini">
          <img src="@/assets/images/home/ewm.png" />
        </div>
        <div class="right-phone">400-8000-211</div>
      </div>
    </div>
    <div class="copy-right">版权所有 © 2020 IPMASTER 鄂ICP备<a href="https://beian.miit.gov.cn/" target="_blank">2022006306</a>号</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.home-bottom {
  width: 100%;
  color: #fff;
  background: url(@/assets/images/home/bg-common-footer.png) no-repeat center;
  background-size: 1920px auto;
  .company-addr {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 1200px;
    height: 180px;
    margin: 40px auto 0;
    border-bottom: 1px solid #3a3e55;
    margin-top: 0px;
    .addr-left {
      flex: 1;
      text-align: left;
      .source-company {
        font-size: $font-size-medium;
        font-weight: bold;
        color: #fff;
        line-height: 16px;
      }
      .source-address {
        font-size: $font-size-medium;
        color: #fff;
        margin-top: 32px;
        margin-bottom: 8px;
        line-height: 16px;
      }
      .source-email {
        font-size: $font-size-medium;
        color: #fff;
      }
    }
    .addr-right {
      .right-mini {
        img {
          width: 76px;
          height: 76px;
        }
      }
      .right-phone {
        margin-top: 10px;
        font-size: $font-size-medium-x;
        font-weight: bold;
        color: #fff;
        line-height: 16px;
      }
    }
  }
  .copy-right {
    width: 100%;
    font-size: $font-size-small;
    color: #bbb;
    line-height: 16px;
    text-align: center;
    padding: 28px 0;
  }
}
</style>
